/**
 * Single-line address for compact UI (e.g. header strip).
 */
export function formatPublicAddressSingleLine(address) {
    if (!address || typeof address !== 'object') return '';
    const parts = [];
    if (address.street) parts.push(String(address.street).trim());
    const cityState = [address.city, address.state].filter(Boolean).join(', ').trim();
    if (cityState) parts.push(cityState);
    if (address.zipCode) parts.push(String(address.zipCode).trim());
    if (address.country) parts.push(String(address.country).trim());
    return parts.filter(Boolean).join(' · ');
}

/** True when any address field has real content (empty `{}` counts as missing). */
export function hasPublicAddress(address) {
    return formatPublicAddressSingleLine(address).length > 0;
}
